module.exports = __webpack_public_path__ + "img/animals_shibainu.c83f87e0.png";